import { render, staticRenderFns } from "./BuyItem.vue?vue&type=template&id=728c7eda&scoped=true&"
import script from "./BuyItem.vue?vue&type=script&lang=ts&"
export * from "./BuyItem.vue?vue&type=script&lang=ts&"
import style0 from "./BuyItem.vue?vue&type=style&index=0&id=728c7eda&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728c7eda",
  null
  
)

export default component.exports